const createError = errorObj => {
  const error = new Error(errorObj.message);
  error.data = errorObj;
  return error;
};

export default createError;
